<sb-split-button color="secondary" [menuItems]="menuItems"></sb-split-button>
